module.exports = __webpack_public_path__ + "img/progress-task-top-anomaly.f6ac36ea.png";